import { useState } from "react";
import AuthenticatedFileImage from "../../Common/AuthenticatedFileImage/AuthenticatedFileImage";
import ImageModal from "../../Common/ImageModal/ImageModal";
import "./PubblicazioneCoverCell.scss";

const PubblicazioneCoverCell = ({ coverId, alt }) => {
  const [isPreviewOpen, setIsPreviewOpen] = useState(false);

  if (!coverId) {
    return <span className="pubblicazione-table-cover--empty">—</span>;
  }

  return (
    <>
      <button
        type="button"
        className="pubblicazione-table-cover-button"
        onClick={() => setIsPreviewOpen(true)}
        aria-label="Visualizza copertina"
      >
        <AuthenticatedFileImage
          src={coverId}
          alt={alt}
          className="pubblicazione-table-cover"
          fallback={
            <span className="pubblicazione-table-cover--empty">—</span>
          }
        />
      </button>
      <ImageModal
        title={alt || "Copertina"}
        isVisible={isPreviewOpen}
        onClose={() => setIsPreviewOpen(false)}
      >
        <AuthenticatedFileImage
          src={coverId}
          alt={alt}
          className="pubblicazione-cover-preview"
        />
      </ImageModal>
    </>
  );
};

export default PubblicazioneCoverCell;
